import styled from 'styled-components';
import { MapsWidget } from '../../Widgets/MapsWidget';
import { WidgetsOverlay } from '../../Widgets/WidgetsOverlay';
import Theme from '../../../styles/Theme/Theme';

const BackgroundMap = styled.div`
  position: relative;
`;
const MapContainer = styled.div`
    position: absolute;
    width: 100%;
	height: 99%;
    top: 0;
    left: 0;
    /* background: blue; */
`;

const Overlay = styled.div`
    padding: ${Theme.spacing['s07']} ${Theme.spacing['s06']};
    z-index: 1;
`;

export const MapOverlay = () => {
    return (
        <BackgroundMap>
            <MapContainer>
                <MapsWidget widgetHeight='100%'/>
            </MapContainer>
            <Overlay>
                <WidgetsOverlay />
            </Overlay>
        </BackgroundMap>
    )
}